import apiClient from "../../../api/core/apiClient";
import type {
  CustomerState,
  CreateCustomerStateDto,
  UpdateCustomerStateDto,
  GetCustomerStatesParams
} from "../types/customer-states.types";

const BASE = '/crm/customer-states';

export const getCustomerStates = (params?: GetCustomerStatesParams): Promise<{ data: CustomerState[], meta?: { total: number } } | CustomerState[]> =>
  apiClient.get(BASE, params);

export const createCustomerState = (data: CreateCustomerStateDto): Promise<CustomerState> =>
  apiClient.post(BASE, data);

export const updateCustomerState = (id: string, data: Omit<UpdateCustomerStateDto, 'id'>): Promise<CustomerState> =>
  apiClient.put(`${BASE}/${id}`, data);

export const deleteCustomerState = (id: string): Promise<void> =>
  apiClient.delete(`${BASE}/${id}`);

export const getCustomerStateTransitions = (id: string): Promise<string[]> =>
  apiClient.get(`${BASE}/${id}/transitions`);

export const updateCustomerStateTransitions = (id: string, allowed_transition_ids: string[]): Promise<void> =>
  apiClient.put(`${BASE}/${id}/transitions`, { allowed_transition_ids });
